module.exports = __webpack_public_path__ + "img/11_1.4e7a49e7.png";